import { render, staticRenderFns } from "./ChannelsFilterBadge.vue?vue&type=template&id=f68c7366&"
import script from "./ChannelsFilterBadge.vue?vue&type=script&lang=js&"
export * from "./ChannelsFilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports